import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Chip,
  IconButton,
  TableFooter,
  TablePagination,
  Button,
} from "@mui/material";
import { Box } from "@mui/system";
import { useTheme } from "@emotion/react";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import useUser from "../../hooks/useUser";
import Swal from "sweetalert2";
import useProducts from "../../hooks/useProducts";
import ModalAdd from "./Modals/ModalAdd";

const columns = [
  { id: "#", label: "#", minWidth: 170 },
  { id: "Nombre", label: "Nombre", minWidth: 170 },
  { id: "Correo", label: "Correo", minWidth: 170 },
  { id: "Distribuidor", label: "Distribuidor", minWidth: 100 },
  { id: "Editar", label: "Editar", minWidth: 100 },
];

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

export default function Index() {
  const { tokenFull, IdUser, Puntos } = useUser();
  const { success, message, error, VendedorGetService, Vendedor } =
    useProducts();
  const [Correo, setCorreo] = useState("");
  const [Pagina, setPagina] = useState(0);
  const [modal, setModal] = useState(false);
  const [Update, setUpdate] = useState(false);
  const [Id, setId] = useState("");
  const [DistribuidorID, setDistribuidorID] = useState("");
  const [Email, setEmail] = useState("");

  const BuscarPorCorreo = () => {
    const data = new FormData();
    data.append("email", Correo);

    VendedorGetService(data, tokenFull);

    Swal.fire({
      title: "Buscando...",
      text: "Loading...",
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      icon: "question",
      onOpen: () => {
        Swal.showLoading();
      },
    });
  };

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, error]);

  useEffect(() => {
    if (success) {
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Exito",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
      setCorreo("");
    }
  }, [message, success]);

  const toggle = () => {
    setModal(!modal);
    setUpdate(false);
    setId("");
    setDistribuidorID("");
  };

  return (
    <>
    {modal && (
      <ModalAdd 
      modal={modal}
      toggle={toggle}
      DistribuidorID={DistribuidorID}
      Email={Email}
      Update={Update}
      tokenFull={tokenFull}
      Id={Id}
      setDistribuidorID={setDistribuidorID}
      setEmail={setEmail}
      VendedorGetService={VendedorGetService}
    />
    )
    }
      
      <div className="container">
        <div className="row">
          <div className="col-md-12" style={{ marginTop: 50 }}>
            <h2 className="titulo2">Buscar Vendedor</h2>
            <div className="col-md-4">
              <label>Correo</label>
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Correo electronico"
                  aria-label="Correo electronico"
                  aria-describedby="button-addon2"
                  onChange={(e) => setCorreo(e.target.value)}
                />
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  id="button-addon2"
                  onClick={() => BuscarPorCorreo()}
                >
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <div className="row">
          <div className="col-md-12">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {columns.map((column, index) => (
                      <TableCell
                        key={index}
                        className="text-center"
                        style={{ background: "#ed7100" }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Vendedor.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  ).map((row, index) => {
                    console.log(row);
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell key={index} className="text-center">
                          {(page + 1) * rowsPerPage - rowsPerPage + (index + 1)}
                        </TableCell>
                        <TableCell key={index} className="text-center">
                          {row.nombre} {row.apellido_paterno}{" "}
                          {row.apellido_materno}
                        </TableCell>
                        <TableCell key={index} className="text-center">
                          {row.email}
                        </TableCell>
                        <TableCell key={index} className="text-center">
                          {row.dealer_id}
                        </TableCell>
                        <TableCell key={index} className="text-center">
                          <button className="btn btn-warning btn-sm"
                          onClick={() => {
                            setId(row.id);
                            setDistribuidorID(row.dealer_id);
                            setEmail(row.email);
                            setUpdate(true);
                            setModal(true);
                        }}>
                            Editar
                          </button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        25,
                        { label: "Todos", value: -1 },
                      ]}
                      colSpan={10}
                      count={Vendedor.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: {
                          "aria-label": "filas por página",
                        },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </>
  );
}
